import script from "./ElCardSectionWithIconText.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElCardSectionWithIconText.vue?vue&type=script&lang=ts&setup=true"

import "./ElCardSectionWithIconText.vue?vue&type=style&index=0&id=40a36f7d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a36f7d"]])

export default __exports__